module.exports = __webpack_public_path__ + "media/images/Rectangle 2.1-2f3541cc8e9aef269f1b073e6b752b5c.png";